import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import { getKolById } from "../../../apis/patientKols";
import { toastify } from "../../../helperFunctions/toastify";
import {
	customDateSort,
	customStringSort,
	getInvoiceId,
} from "../../../helperFunctions/utils";

export default function KolDetails() {
	const params = useParams();
	const navigate = useNavigate();

	const [kolData, setKolData] = useState({});

	useEffect(() => {
		(async () => {
			const { result, error } = await getKolById(params.id);
			if (error) {
				toastify(
					error.message ?? "Failed to get influencer data",
					"error",
				);
				return;
			}
			// console.log("asdasd", result.data);
			setKolData(result.data);
		})();
	}, []);

	const spending_columns = [
		{
			name: "Date",
			selector: (row) => row.date,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customDateSort(a, b, "date"),
		},
		{
			name: "Spending Products",
			selector: (row) => row.products,
			wrap: true,
		},
		{
			name: "Spending Treatments",
			selector: (row) => row.treatments,
			wrap: true,
		},
		{
			name: "Spending Packages",
			selector: (row) => row.packages,
			wrap: true,
		},
		{
			name: "Amount",
			selector: (row) => row.amount,
			wrap: true,
			sortable: true,
		},
	];
	const spending_data = kolData?.billing_details
		?.filter((o) => o.isFirst)
		?.map((o, index) => {
			return {
				index: index,
				billing_id: o._id,
				date: new Date(o?.billing_id?.created_at).toLocaleDateString(),
				amount: o?.billing_id?.totalAmount,
				products: o?.billing_id?.product?.map((k) => {
					return (
						<>
							<div>{k?.product_id?.name}</div>
						</>
					);
				}),

				treatments: o?.billing_id?.treatment?.map((k) => {
					return (
						<>
							<div>{k?.service_id?.name}</div>
						</>
					);
				}),

				packages: o?.billing_id?.package?.map((k) => {
					return (
						<>
							<div>{k?.package_id?.name}</div>
						</>
					);
				}),
			};
		});

	const revenue_columns = [
		{
			name: "Date",
			selector: (row) => row.date,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customDateSort(a, b, "date"),
		},
		{
			name: "Patient Name",
			selector: (row) => row.patientName,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "patientName"),
		},
		{
			name: "Invoice No.",
			selector: (row) => row.invoice,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "invoice"),
		},
		{
			name: "Remarks",
			selector: (row) => row.remarks,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "remarks"),
		},
		{
			name: "Amount",
			selector: (row) => row.amount,
			wrap: true,
			sortable: true,
			// sortFunction: (a, b) => customStringSort(a, b, "name"),
		},
	];
	const revenue_data = kolData?.billing_details
		?.filter((o) => o.isFirst)
		?.map((o, index) => {
			return {
				index: index,
				invoice: o.invoiceId ? getInvoiceId(o.invoiceId) : "-",
				billing_id: o._id,
				date: new Date(o?.billing_id?.created_at).toLocaleDateString(),
				patientName: o?.billing_id?.patient?.patientProfile?.fullName,
				amount: o?.billing_id?.totalAmount,
				remarks: o?.billing_id?.remarks,
			};
		});
	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				backgroundColor: "#f8f8f8",
				borderWidth: "0px",
			},
		},
	];
	return (
		<>
			<div className="container p-0">
				<div className="mainHeading px-4 justify-content-start">
					<i
						className="fa fa-arrow-left cursor-pointer"
						onClick={() => {
							navigate(-1);
						}}
					></i>
					<h1 className="ms-3">Influencer Detail</h1>
				</div>
				<div className="kol-body" style={{ background: "white" }}>
					<div className="row px-4 justify-content-between py-3">
						<Col
							md={3}
							className="d-flex justify-content-between my-2 px-3 py-2"
							style={{ background: "#F8F8F8" }}
						>
							<div>
								<b>Username</b>
							</div>
							<div>
								{kolData?.kol_id?.patientProfile?.fullName}
							</div>
						</Col>
						<Col
							md={3}
							style={{ background: "#F8F8F8" }}
							className="d-flex justify-content-between my-2 px-3 py-2"
						>
							<div>
								<b>Type</b>
							</div>
							<div>{kolData?.kol_type}</div>
						</Col>
						<Col
							md={3}
							style={{ background: "#F8F8F8" }}
							className="d-flex justify-content-between my-2 px-3 py-2"
						>
							<div>
								<b>Objective</b>
							</div>
							<div>{kolData?.objective}</div>
						</Col>
					</div>
					<div className="font-500-20 grey py-1 px-4">
						<b>Spending Amount</b>
						<div className="mt-3">
							<DataTable
								columns={spending_columns}
								data={spending_data || []}
								pagination
								customStyles={customStyles}
								conditionalRowStyles={conditionalRowStyles}
							/>
						</div>
					</div>
					<div className="font-500-20 grey py-1 px-4">
						<b>Revenue</b>
					</div>
					<div className="mt-3">
						<DataTable
							columns={revenue_columns}
							data={revenue_data || []}
							pagination
							customStyles={customStyles}
							conditionalRowStyles={conditionalRowStyles}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
